import styled from "styled-components";

export const Title = styled.h3`
  text-align: center;
`;

export const TilesContainer = styled.div`
  display: grid;
  grid-gap: 0.25rem;
  grid-template-columns: repeat(auto-fill, 50px);
`;
